import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';

function Heading(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);
  var Tag = "h".concat(props.level);
  return /*#__PURE__*/React$1.createElement(Tag, {
    className: props.className
  }, value);
}

Heading.defaultProps = {
  defaultValue: null,
  level: 1,
  className: ''
};
Heading.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  level: PropTypes$1.oneOf([1, 2, 3, 4, 5, 6]),
  className: PropTypes$1.string
};
var Heading$1 = observer(Heading);

export default Heading$1;
//# sourceMappingURL=Heading.js.map
